import axios from 'axios';
import { isValidEmail, isApaLifeEmail } from '@/utils/emailValidation';

export default {
  data() {
    return {
      showAuthModal: false,
      loading2: false,
      authEmail: '',
    };
  },
  methods: {
    validateUsernameOrEmail(username) {
      if (!username) return false;

      // If it's an email format, validate domain
      if (isValidEmail(username)) {
        return isApaLifeEmail(username);
      }

      // Otherwise, validate as agent code (alphanumeric)
      return /^[a-zA-Z0-9]+$/.test(username);
    },

    async requireAuthentication(callback) {
      if (!this.$store.getters['auth/isAuthenticated']) {
        this.showAuthModal = true;
        this.pendingCallback = callback;
        return false;
      }
      return callback();
    },

    async handleAuthModalSubmit(authForm) {
      this.loading2 = true;
      const username = authForm.userName || authForm.email;
      this.authEmail = username;

      // Validate username (agent code or email)
      if (!this.validateUsernameOrEmail(username)) {
        if (isValidEmail(username)) {
          this.$toast.error('Only @apalife.co.ke email addresses are allowed');
        } else {
          this.$toast.error('Please enter a valid agent code or @apalife.co.ke email');
        }
        this.loading2 = false;
        return;
      }

      try {
        const response = await axios.post('/lmsagent/login/AuthenticateSystemUser', {
          userName: username,
          password: authForm.password,
        });

        const userData = response.data;

        if (userData.user) {
          // Store user data in Vuex store
          await this.$store.dispatch('auth/login', userData);

          this.$toast.success('Login successful!');
          this.showAuthModal = false;

          if (this.pendingCallback) {
            this.pendingCallback();
          }
        } else {
          this.$toast.error('Invalid credentials');
        }
      } catch (error) {
        this.$toast.error(error.response?.data?.message || 'Login failed');
      } finally {
        this.loading2 = false;
      }
    },

    async handleLogin(credentials) {
      this.loading2 = true;
      const username = credentials.userName || credentials.email;

      // Validate username (agent code or email)
      if (!this.validateUsernameOrEmail(username)) {
        if (isValidEmail(username)) {
          this.$toast.error('Only @apalife.co.ke email addresses are allowed');
        } else {
          this.$toast.error('Please enter a valid agent code or @apalife.co.ke email');
        }
        this.loading2 = false;
        return;
      }

      try {
        const response = await axios.post('/lmsagent/login/AuthenticateSystemUser', {
          userName: username,
          password: credentials.password,
        });

        const userData = response.data;

        if (userData.user) {
          await this.$store.dispatch('auth/login', userData);
          this.$toast.success('Login successful!');

          // Determine redirect route based on user roles
          const roles = userData.user.roles || [];
          const isAdminUser = roles.includes('ADMINISTRATOR') || roles.includes('STAFF');
          const redirectRoute = isAdminUser ? '/admin' : '/dashboard';

          this.$router.push(redirectRoute);
        } else {
          this.$toast.error('Invalid credentials');
        }
      } catch (error) {
        this.$toast.error(error.response?.data?.message || 'Login failed');
      } finally {
        this.loading2 = false;
      }
    },

    async handleLogout() {
      try {
        await this.$store.dispatch('auth/signOut');
        this.$toast.success('Logged out successfully');
      } catch (error) {
        this.$toast.error(error.response?.data?.message || 'Logout failed');
      }
    },

    checkUserPermissions(requiredRoles = []) {
      const user = this.$store.getters['auth/authenticatedUser'];
      if (!user?.roles) return false;

      if (requiredRoles.length === 0) return true;

      return requiredRoles.some((role) => user.roles.includes(role));
    },

    isAdmin() {
      return this.checkUserPermissions(['ADMIN']);
    },

    isAgent() {
      return this.checkUserPermissions(['AGENT']);
    },
  },
};
